import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import { RecipientStatusList } from './RecipientStatusList';
import { RecipientAccessService } from '@/services/recipientAccessService';
import { PreApprovalRecipient } from '@/types/pre-approval';
import { Skeleton } from '@/components/ui/skeleton';
import { AlertCircle } from 'lucide-react';

interface RecipientStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  preApprovalId: string;
  borrowerName: string;
}

export const RecipientStatusModal: React.FC<RecipientStatusModalProps> = ({
  isOpen,
  onClose,
  preApprovalId,
  borrowerName
}) => {
  const [recipients, setRecipients] = useState<PreApprovalRecipient[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadRecipients = async () => {
      if (!isOpen || !preApprovalId) {
return;
}

      setIsLoading(true);
      try {
        const recipientData = await RecipientAccessService.getRecipientsByPreApproval(preApprovalId);
        setRecipients(recipientData);
      } catch (error) {
        console.error('Failed to load recipient status:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadRecipients();
  }, [isOpen, preApprovalId]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Recipient Tracking</DialogTitle>
          <DialogDescription>
            View who has received and viewed this pre-approval for {borrowerName}
          </DialogDescription>
        </DialogHeader>

        {isLoading ? (
          <div className="space-y-3">
            <Skeleton className="h-20 w-full" />
            <Skeleton className="h-20 w-full" />
            <Skeleton className="h-20 w-full" />
          </div>
        ) : recipients.length === 0 ? (
          <div className="flex items-center justify-center p-8 text-center">
            <div>
              <AlertCircle className="h-12 w-12 text-gray-400 mx-auto mb-3" />
              <p className="text-sm text-gray-500">
                No recipient tracking available for this pre-approval.
              </p>
              <p className="text-xs text-gray-400 mt-1">
                This pre-approval was created before individual recipient tracking was implemented.
              </p>
            </div>
          </div>
        ) : (
          <RecipientStatusList recipients={recipients} />
        )}
      </DialogContent>
    </Dialog>
  );
};
